import { render, staticRenderFns } from "./commentsWriteInput.vue?vue&type=template&id=32978199&"
import script from "./commentsWriteInput.vue?vue&type=script&lang=js&"
export * from "./commentsWriteInput.vue?vue&type=script&lang=js&"
import style0 from "./commentsWriteInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports